var primary = {
  variant: 'primary',
  size: 'std'
};
var primarySmall = {
  variant: 'primary',
  size: 'sm'
};
var secondary = {
  variant: 'secondary',
  size: 'std'
};
var secondarySmall = {
  variant: 'secondary',
  size: 'sm'
};
var tertiary = {
  variant: 'tertiary',
  size: 'std'
};
var neutral = {
  variant: 'neutral',
  size: 'std'
};
var neutralLight = {
  variant: 'neutral-light',
  size: 'std'
};
var neutralLightSmall = {
  variant: 'neutral-light',
  size: 'sm'
};
var neutralSmall = {
  variant: 'neutral',
  size: 'sm'
};
var ghostPrimary = {
  variant: 'ghost-primary',
  size: 'std'
};
var ghostPrimarySmall = {
  variant: 'ghost-primary',
  size: 'sm'
};
var ghostSecondary = {
  variant: 'ghost-secondary',
  size: 'std'
};
var ghostSecondarySmall = {
  variant: 'ghost-secondary',
  size: 'sm'
};
var ghostNeutral = {
  variant: 'ghost-neutral',
  size: 'std'
};
var ghostNeutralSmall = {
  variant: 'ghost-neutral',
  size: 'sm'
};
var ghostToggle = {
  variant: 'ghost-toggle',
  size: 'std'
};
var buttonLink = {
  variant: 'button-link'
};
var ghostSecondaryRounded = {
  variant: 'ghost-secondary-rounded',
  size: 'std'
};
var statusNegative = {
  variant: 'status-negative'
};
var menuItem = {
  variant: 'menu-item'
};
var expander = {
  variant: 'expander',
  size: 'std'
};
var buttonVariants = {
  primary: primary,
  'primary-sm': primarySmall,
  secondary: secondary,
  'secondary-sm': secondarySmall,
  tertiary: tertiary,
  neutral: neutral,
  'status-negative': statusNegative,
  'neutral-light': neutralLight,
  'neutral-light-sm': neutralLightSmall,
  'neutral-sm': neutralSmall,
  'ghost-primary': ghostPrimary,
  'ghost-primary-sm': ghostPrimarySmall,
  'ghost-secondary': ghostSecondary,
  'ghost-secondary-sm': ghostSecondarySmall,
  'ghost-neutral': ghostNeutral,
  'ghost-neutral-sm': ghostNeutralSmall,
  'ghost-toggle': ghostToggle,
  'button-link': buttonLink,
  'ghost-secondary-rounded': ghostSecondaryRounded,
  'menu-item': menuItem,
  expander: expander
};

export { buttonVariants };
//# sourceMappingURL=button.variants.esm.js.map
